import React from "react";
import { css } from "aphrodite";
import GlobalSlider from "../../GenericComponents/GlobalSlider";
import styles from "../style";
import { Form } from "react-bootstrap";

class HighHRThresholdCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { highHRSettings, defaultSettings, handleSliderValues } = this.props;
    const min = parseInt(defaultSettings.HIGH_HR_THRESHOLD.minValue);
    const max = parseInt(defaultSettings.HIGH_HR_THRESHOLD.maxValue);
    const step = 5;
    const highHRThresholdValue =
      typeof highHRSettings.highHRThreshold === "number"
        ? highHRSettings.highHRThreshold
        : parseInt(highHRSettings.highHRThreshold ?? 0);
    return (
      Object.keys(highHRSettings).length !== 0 && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <label
              className={css(styles.valueLabels)}
              style={{ paddingTop: 20 }}
            >
              High HR Threshold Event value (
              {defaultSettings.HIGH_HR_THRESHOLD.minValue} -{" "}
              {defaultSettings.HIGH_HR_THRESHOLD.maxValue}{" "}
              {defaultSettings.HIGH_HR_THRESHOLD.unit})
            </label>
            <Form.Select
              name="highHRThreshold"
              style={{ width: 140 }}
              value={
                Number.isFinite(highHRThresholdValue) ? highHRThresholdValue : 0
              }
              onChange={(e) =>
                handleSliderValues(
                  "highHRThreshold",
                  parseInt(e.target.value, 10),
                )
              }
            >
              <option value={0}>OFF</option>
              {Array.from(
                { length: Math.floor((max - min) / step) + 1 },
                (_, idx) => min + idx * step,
              ).map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </Form.Select>
          </div>
          <label
            style={{ fontSize: "14px", marginBottom: "1em", color: "black" }}
          >
            How long should high HR last before alert. Choose (
            {defaultSettings.HIGH_HR_THRESHOLD_DURATION.minValue} -{" "}
            {defaultSettings.HIGH_HR_THRESHOLD_DURATION.maxValue}{" "}
            {defaultSettings.HIGH_HR_THRESHOLD_DURATION.unit})<br />
          </label>
          <GlobalSlider
            name={"highHRThresholdDuration"}
            min={parseInt(defaultSettings.HIGH_HR_THRESHOLD_DURATION.minValue)}
            max={parseInt(defaultSettings.HIGH_HR_THRESHOLD_DURATION.maxValue)}
            step={1}
            value={highHRSettings.highHRThresholdDuration}
            action={handleSliderValues}
          />
        </div>
      )
    );
  }
}

export default HighHRThresholdCard;
